import { getUsePaymentMethodStep } from '../brand/brandSelectors';

import { paymentMethodPostConditions, paymentMethodPreConditions } from './paymentMethodStepSelectors';


const paymentMethodStepConfig = {
    component: () => import('./PaymentMethodStep'),
    flow: 'postBuy',
    canLoad: (state, ownProps) => {
        const { submitPath } = ownProps;
        return { isAllowedOrPath: getUsePaymentMethodStep(state) || submitPath };
    },
    preConditions: paymentMethodPreConditions,
    postConditions: paymentMethodPostConditions
};

export default paymentMethodStepConfig;
